import {
  Box,
  Chip,
  Divider,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import { SecToTimecode } from "../../Utils/Timecode/ReactPlayer";
import Logo from "../../Components/Logo/logo-svg";
import { useDispatch } from "react-redux";
import { SetFps } from "../../Redux/Reducers/redux-slice-timetool";
import { useTranslation } from "react-i18next";

type TimetoolFooterProps = {
  sequenceName: string;
  fps: number;
  clipCount: number;
  sequenceDuration: number;
};

export const TimetoolFooter: React.FC<TimetoolFooterProps> = ({ sequenceDuration, clipCount, fps, sequenceName }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const dispatch = useDispatch();
  return (
    <footer
      style={{
        borderRadius: "6px 6px 0px 0px",
        marginRight: 6,
        marginLeft: 6,
        height: "36px",
        position: "absolute",
        bottom: "0px",
        left: "0px",
        right: "0px",
        zIndex: 100000,
        backgroundColor: theme.palette.background[200],
        overflow: "hidden",
      }}
    >
      <Stack alignItems={"center"} display={"flex"} justifyContent={"space-between"} flexDirection={"row"}>
        <Stack
          sx={{ color: theme.palette.grey[400], pb: 0.5, pt: 0.7 }}
          height="100%"
          direction="row"
          display="flex"
          alignItems="center"
          alignContent="center"
        >
          <Typography sx={{ ml: 1.5 }} variant="body1">
            {t("page:body.totalTime")}
          </Typography>
          <Chip label={`${SecToTimecode(sequenceDuration / fps, fps)}`} sx={{ ml: 1.5, mr: 1.5 }} />
          <Divider sx={{ display: "list-item" }} orientation="vertical" />
          <Typography sx={{ ml: 1.5 }} variant="body1">
            {t("page:body.fpsRendering")}
          </Typography>
          {/* <FormControl sx={{ ml: 1.5 }} size="small">
            <Select
              labelId="demo-select-small-label"
              id="demo-select-small"
              label="Fps rendering"
              onChange={(e) => {
                dispatch(SetFps(e.target.value as number));
              }}
              value={fps}
            >
              <MenuItem value={25}>25</MenuItem>
              <MenuItem value={24}>24</MenuItem>
              <MenuItem value={23.98}>23.98</MenuItem>
              <MenuItem disabled value={1}>
                1
              </MenuItem>
            </Select>
          </FormControl> */}
          <Chip label={`${fps} fps`} sx={{ ml: 1.5, mr: 1.5 }} />
          <Divider sx={{ display: "list-item" }} orientation="vertical" />
          <Typography sx={{ ml: 1.5 }} variant="body1">
            {t("field:label.sequenceName")}
          </Typography>
          <Chip label={sequenceName} sx={{ ml: 1.5, mr: 1.5 }} />
          <Divider sx={{ display: "list-item" }} orientation="vertical" />
          <Typography sx={{ ml: 1.5 }} variant="body1">
            {t("page:body.clipCount")}
          </Typography>
          <Chip label={t("common:clipsWithCount", { count: clipCount })} sx={{ ml: 1, mr: 1 }} />
        </Stack>
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Logo color={theme.palette.text.primary} sx={{ mr: 1.5 }} />
        </Box>
      </Stack>
    </footer>
  );
};
